<template>
  <div class="revenue-dashboard">
    <!-- KPI Cards -->
    <revenue-card :item="kpiCards" />

    <!-- Needs Attention + Live Throughput -->
    <div class="dashboard-sections">
      <!-- Needs Attention -->
      <v-card class="dashboard-card">
        <v-card-text>
          <div class="section-title">
            <span>Needs attention</span>
            <span class="count-badge">5</span>
          </div>

          <div
            v-for="(item, index) in attentionItems"
            :key="index"
            class="attention-item"
          >
            <div
              class="status-dot"
              :class="`status-${item.status}`"
            />

            <div class="attention-content">
              <div class="attention-header">
                <div>
                  <span class="attention-title">
                    {{ item.title }}
                  </span>

                  <span class="attention-location">
                    · {{ item.location }}
                  </span>
                </div>

                <span class="attention-time">
                  {{ item.time }}
                </span>
              </div>

              <div class="attention-description">
                {{ item.description }}
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>

      <!-- Live Throughput -->
      <v-card class="dashboard-card">
        <v-card-text>
          <div class="section-title">
            Live throughput
          </div>

          <div
            v-for="(item, index) in throughputItems"
            :key="index"
            class="throughput-item"
          >
            <span class="throughput-label">
              {{ item.label }}
            </span>

            <span class="throughput-value">
              {{ item.value }}
              <small v-if="item.unit">
                {{ item.unit }}
              </small>
            </span>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <!-- Trends & Locations -->
    <div class="trends-section">
      <div class="trends-header">
        <span class="trends-title">TRENDS & LOCATIONS</span>
        <span class="trends-subtitle">last 14 days</span>
      </div>

      <div class="trends-grid">
        <!-- Availability trend Card -->
        <v-card
          class="analytics-card"
          flat
        >
          <v-card-text>
            <div class="card-title">
              Availability trend
            </div>

            <div class="chart-wrapper">
              <!-- <apexchart
                type="line"
                height="300"
                :options="trendChartOptions"
                :series="trendSeries"
              /> -->
              <apexchart
                type="line"
                height="300"
                :options="chartOptions"
                :series="series"
              />
            </div>
          </v-card-text>
        </v-card>

        <!-- Sites by city Card -->
        <v-card
          class="analytics-card"
          flat
        >
          <v-card-text>
            <div class="card-title">
              Sites by city
            </div>

            <div class="city-list">
              <div
                v-for="(city, index) in citySites"
                :key="index"
                class="city-item"
              >
                <span class="city-name">{{ city.name }}</span>

                <div class="progress-bar-container">
                  <div
                    class="progress-bar-fill"
                    :style="{ width: city.percentage + '%' }"
                  />
                </div>

                <span class="city-count">{{ city.count }}</span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    RevenueCard: () => import("../utils/RevenueCards.vue"),
    apexchart: VueApexCharts,
  },

  data() {
    return {
      kpiCards: [
        {
          title: "Charger Availability",
          status: "breached",
          value: 38.75,
          unit: "%",
          text: "Target 98%",
          progress: 50,
        },
        {
          title: "Open Faults",
          status: "breached",
          value: 153,
          unit: "",
          text: "Target 0 - 153 open",
          progress: 35,
        },
        {
          title: "First-time Charge Success",
          status: "breached",
          value: 34.71,
          unit: "%",
          text: "Target 95%",
          progress: 80,
        },
        {
          title: "Mean Time To Repair",
          status: "at risk",
          value: 4.2,
          unit: "h",
          text: "Target 4h",
          progress: 100,
        },
      ],

      attentionItems: [
        {
          title: "F-7 Markaz",
          location: "Islamabad",
          description: "Availability 41% — SLA is 98%",
          time: "today",
          status: "red",
        },
        {
          title: "Clifton Block 5",
          location: "Karachi",
          description: "3 connectors offline",
          time: "2h 40m",
          status: "red",
        },
        {
          title: "Blue Area",
          location: "Islamabad",
          description: "Charger unreachable — comms fault",
          time: "55m",
          status: "red",
        },
        {
          title: "DHA Phase 6",
          location: "Karachi",
          description: "Ground fault cleared — monitoring",
          time: "20m",
          status: "yellow",
        },
        {
          title: "G-9 Markaz",
          location: "Islamabad",
          description: "Elevated MTTR on 2 units",
          time: "today",
          status: "yellow",
        },
      ],

      throughputItems: [
        {
          label: "Active sessions",
          value: 2,
          unit: "",
          type: "green",
        },
        {
          label: "Sessions today",
          value: 42,
          unit: "",
        },
        {
          label: "Energy dispensed",
          value: "907.86",
          unit: "kWh",
        },
        {
          label: "Revenue today",
          value: "Rs 110,685.87",
          unit: "",
        },
        {
          label: "Avg charge / session",
          value: "49.1",
          unit: "%",
        },
        {
          label: "New users",
          value: 42,
          unit: "",
        },
      ],

      // Trends & Locations Data
      series: [
        {
          name: "Availability",
          data: [78, 70, 85, 58, 50, 44, 52, 35, 28, 32, 20, 22, 18],
        },
        {
          name: "Baseline",
          data: [35, 20, 42, 34, 52, 40, 68, 52, 78, 58, 72, 60, 56],
        },
      ],
      chartOptions: {
        chart: {
          type: "line",
          toolbar: { show: false },
          zoom: { enabled: false },
        },
        colors: ["#1b7a63", "#e08369"],
        stroke: {
          curve: "straight",
          width: 3,
        },
        markers: {
          size: [0, 0],
          hover: { size: 6 },
        },
        grid: {
          show: false,
        },
        xaxis: {
          labels: { show: false },
          axisBorder: { show: false },
          axisTicks: { show: false },
        },
        yaxis: {
          labels: { show: false },
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          fontSize: "13px",
          markers: {
            width: 12,
            height: 3,
            radius: 2,
          },
        },
        tooltip: {
          theme: "light",
        },
      },

      citySites: [
        { name: "Islamabad", count: 5, percentage: 100 },
        { name: "Karachi", count: 3, percentage: 60 },
      ],
    };
  },
};
</script>

<style lang="sass" scoped>

.revenue-dashboard
  width: 100%

.dashboard-sections
  display: grid
  grid-template-columns: 1fr 0.86fr
  gap: 1rem
  margin-top: 1rem

.dashboard-card
  border-radius: 16px !important
  overflow: hidden

.section-title
  display: flex
  align-items: center
  gap: 10px
  font-size: 16px
  font-weight: 600
  margin-bottom: 1rem

.count-badge
  display: inline-flex
  align-items: center
  justify-content: center
  min-width: 25px
  height: 25px
  padding: 0 7px
  border-radius: 20px
  background: #ef6b72
  color: white
  font-size: 12px
  font-weight: 600

.attention-item
  display: flex
  align-items: flex-start
  gap: 15px
  padding: 16px 0
  border-bottom: 1px solid rgba(255, 255, 255, 0.08)

  &:last-child
    border-bottom: none
    padding-bottom: 0

.status-dot
  width: 11px
  height: 11px
  min-width: 11px
  margin-top: 5px
  border-radius: 50%

.status-red
  background: #ff6b72

.status-yellow
  background: #ffc21c

.attention-content
  width: 100%

.attention-header
  display: flex
  justify-content: space-between
  align-items: center
  gap: 10px

.attention-title
  font-size: 15px
  font-weight: 600

.attention-location
  color: #7182a3
  font-size: 13px

.attention-time
  color: #7182a3
  font-size: 12px
  white-space: nowrap

.attention-description
  margin-top: 5px
  color: #91a1c0
  font-size: 13px

.throughput-item
  display: flex
  justify-content: space-between
  align-items: center
  min-height: 47px
  border-bottom: 1px solid rgba(255, 255, 255, 0.08)

  &:last-child
    border-bottom: none

.throughput-label
  font-size: 14px

.throughput-value
  font-size: 14px
  font-weight: 600
  text-align: right

  small
    margin-left: 5px
    color: #91a1c0
    font-size: 11px
    font-weight: 400

/* Trends & Locations Section */
.trends-section
  margin-top: 1.5rem

.trends-header
  display: flex
  align-items: center
  gap: 8px
  margin-bottom: 0.75rem

.trends-title
  font-size: 12px
  font-weight: 700
  letter-spacing: 0.8px
  color: #8fa0be
  text-transform: uppercase

.trends-subtitle
  font-size: 12px
  color: #8fa0be

.trends-grid
  display: grid
  grid-template-columns: 1fr 1fr
  gap: 1rem

.analytics-card
  border-radius: 16px !important
  background: #ffffff !important
  border: 1px solid #f0f2f5

.card-title
  font-size: 15px
  font-weight: 700
  color: #111827
  margin-bottom: 0.5rem

.chart-wrapper
  margin-top: 1rem

.city-list
  display: flex
  flex-direction: column
  gap: 1.25rem
  margin-top: 1rem

.city-item
  display: grid
  grid-template-columns: 100px 1fr 30px
  align-items: center
  gap: 1rem
  padding-bottom: 0.75rem
  border-bottom: 1px solid #f3f4f6

  &:last-child
    border-bottom: none
    padding-bottom: 0

.city-name
  font-size: 14px
  font-weight: 600
  color: #1f2937

.progress-bar-container
  width: 100%
  height: 10px
  background-color: #f3f4f6
  border-radius: 6px
  overflow: hidden

.progress-bar-fill
  height: 100%
  background-color: #1b7a63
  border-radius: 6px

.city-count
  font-size: 14px
  color: #111827
  text-align: right
  font-weight: 700

@media (max-width: 1024px)
  .dashboard-sections,
  .trends-grid
    grid-template-columns: 1fr

@media (max-width: 600px)
  .dashboard-sections
    gap: 12px

  .dashboard-card
    border-radius: 12px !important

  .attention-header
    align-items: flex-start

  .attention-title
    font-size: 14px

  .attention-location
    font-size: 12px

  .attention-description
    font-size: 12px

  .throughput-label,
  .throughput-value
    font-size: 13px
</style>
